import React, { useCallback } from 'react'
import { Typography } from 'antd'
import PropTypes from 'prop-types'

import { useQueryParams } from '../../../core/hooks'

import { idPropType } from '../../prop-types'

import MetadataHistoryDrawer from './metadata-history-drawer'

const HistoryLink = ({
  entityId,
  eventTypes,
  eventMetadataTypes,
  renderEvent,
  filterEventTypes,
}) => {
  const { isHistoryVisible, setQueryParams } = useQueryParams()

  const handleOpenHistory = useCallback(
    () => setQueryParams({ isHistoryVisible: true }),
    [setQueryParams],
  )

  const handleCloseHistory = useCallback(
    filters => setQueryParams({ ...filters, isHistoryVisible: null }),
    [setQueryParams],
  )

  return (
    <>
      <Typography.Link onClick={handleOpenHistory}>History</Typography.Link>

      {isHistoryVisible && (
        <MetadataHistoryDrawer
          eventMetadataTypes={eventMetadataTypes}
          eventTypes={eventTypes}
          renderEvent={renderEvent}
          entityId={entityId}
          onClose={handleCloseHistory}
          filterEventTypes={filterEventTypes}
        />
      )}
    </>
  )
}

HistoryLink.propTypes = {
  eventMetadataTypes: PropTypes.arrayOf(PropTypes.string),
  eventTypes: PropTypes.arrayOf(PropTypes.string),
  renderEvent: PropTypes.func,
  entityId: idPropType,
  filterEventTypes: PropTypes.bool,
}

HistoryLink.defaultProps = {
  eventMetadataTypes: [],
  entityId: undefined,
  eventTypes: [],
  renderEvent: undefined,
  filterEventTypes: false,
}

export default HistoryLink
